import { Component, HostBinding, OnInit } from '@angular/core';
import { ConfigService } from '../../../../services/config.service';
import { UserService } from '../../../../services/user.service';
import { ThemeService } from '../../../../services/theme.service';
import { take } from 'rxjs';
import { UserFacade } from '../../../../_core/state/user/user.facade';

@Component({
  selector: 'app-header-banners',
  templateUrl: './header-banners.component.html',
  styleUrls: ['./header-banners.component.scss'],
})
export class HeaderBannersComponent implements OnInit {
  @HostBinding('class.has-banners') get hasBanners() {
    return this.showSelfPublishBanner || this.showTwentyFourSymbolsBanner || this.showRemoteLoginBanner;
  }

  showSelfPublishBanner: boolean = false;
  selfPublishImgSrc: string = '';
  selfPublishHref: string = '';

  showTwentyFourSymbolsBanner: boolean = false;
  twentyFourSymbolsImgSrc: string = '';
  twentyFourSymbolsHref: string = '';

  showRemoteLoginBanner: boolean = false;
  remoteLoginHref: string = '';
  remoteLoginImgAlt: string = '';
  remoteLoginImgSrc: string = '';

  constructor(
    private readonly configService: ConfigService,
    private readonly themeService: ThemeService,
    private readonly userService: UserService,
    private readonly userFacade: UserFacade
  ) {}

  ngOnInit(): void {
    this.selfPublishHref = this.configService.get().selfPublishingUrl;
    if (this.selfPublishHref) {
      // AulaMadrid asked for removing a custom "Calendar button" displayed with this image if user origin (TIPOLEC) is TURISMO
      // @see https://odilotid.atlassian.net/browse/ORN-4853
      if (this.configService.isAulaMadrid() && this.userFacade.user.origin === 'TURISMO') {
        this.showSelfPublishBanner = false;
      } else {
        this.showSelfPublishBanner = true;
      }
      this.selfPublishImgSrc = this.themeService.selfPublicationBannerUrl;
    }

    this.showTwentyFourSymbolsBanner = this.configService.get().show24SymbolsBanner;
    if (this.showTwentyFourSymbolsBanner && this.userService.getUserId()) {
      this.twentyFourSymbolsImgSrc = this.themeService.twentyFourSymbolsBannerUrl;
      this.userService
        .get24SymbolsLoginUrl()
        .pipe(take(1))
        .subscribe(({ url }) => (this.twentyFourSymbolsHref = url));
    }

    this.showRemoteLoginBanner = this.configService.get().showRemoteLoginBanner;
    if (this.showRemoteLoginBanner) {
      const clientCode = this.configService.get().codCliente.toUpperCase();
      const library = this.userService.getLibrary().toUpperCase();

      if (clientCode === 'E0445' && library === 'BI045') {
        this.remoteLoginImgAlt = 'Bibliotecas municipales de Cartagena';
        this.remoteLoginImgSrc = '../../../assets/remote-otk-banners/logo_bmct.png';
      } else {
        this.remoteLoginImgSrc = this.themeService.remoteLoginBannerUrl;
      }

      if (this.userService.getUserId()) {
        this.userService.getRemoteLoginUrl().subscribe(({ url }) => (this.remoteLoginHref = url));
      }
    }
  }

  handleTwentyFourClick(event: Event) {
    event.preventDefault();
    window.postMessage({ href: this.twentyFourSymbolsHref, target: '_blank' }, '*');
    window.open(this.twentyFourSymbolsHref, '_blank', 'noopener');
  }
}
